



















import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { IComment } from '@signing-page/chat/types/comment';
import ChatComment from '@signing-page/chat/components/ChatComment.vue';
import { IUser } from '@/types/User';
import { IRecipient } from '@signing-page/documents/types/recipient';
import { ChatHelper } from '@signing-page/chat/helpers/chat.helper';

@Component({
  components: { ChatComment },
  data: () => ({
    ChatHelper,
  }),
})
export default class ChatContent extends Vue {
  @Prop() me!: string;
  @Prop() user!: IUser;
  @Prop() comments!: IComment[];
  @Prop() recipients!: IRecipient[];

  @Watch('comments')
  commentAdded(): void {
    setTimeout(() => {
      this.scrollToBottom();
    }, 100);
  }

  firstCommentInMonologue(comment: IComment, comments: IComment[]) {
    return (
      ChatHelper.firstCommentInMonologue(comment, comments) || this.isFirstCommentThatDay(comment)
    );
  }

  getRecipient(recipientId: string): IRecipient {
    return this.recipients.find((recipient: IRecipient) => recipient.id === recipientId);
  }

  previousComment(comment: IComment): IComment {
    return this.comments[this.comments.indexOf(comment) - 1];
  }

  isFirstCommentThatDay(comment: IComment): boolean {
    if (this.comments.indexOf(comment) < 1) {
      return true;
    }
    return moment(comment.createdAt).isAfter(this.previousComment(comment).createdAt, 'day');
  }

  scrollToBottom() {
    const container = this.$refs.chatContent as Element;
    if (!container) {
      return;
    }
    container.scrollTop = container.scrollHeight;
  }

  mounted() {
    this.scrollToBottom();
    window.addEventListener('resize', () => {
      if (window.innerWidth <= 600) {
        this.scrollToBottom();
      }
    });
  }

  beforeDestroy() {
    window.removeEventListener('resize', () => {
      if (window.innerWidth <= 600) {
        this.scrollToBottom();
      }
    });
  }
}
